import React, { useState } from "react";

const MAX_LENGTH = 2000;

export const MessageComposer = ({
  disabled,
  onSend,
  placeholder = "Type a message",
}) => {
  const [draft, setDraft] = useState("");
  const [sending, setSending] = useState(false);

  const trimmed = draft.trim();
  const canSend = !disabled && !sending && trimmed.length > 0 && draft.length <= MAX_LENGTH;

  const handleSend = async () => {
    if (!canSend) return;
    setSending(true);
    try {
      const sent = await onSend(trimmed);
      if (sent) setDraft("");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ticket-chat-composer">
      <div className="ticket-chat-composer-row">
        <button
          type="button"
          className="ticket-chat-icon-btn"
          disabled={disabled || sending}
          aria-label="Add attachment"
        >
          +
        </button>
        <button
          type="button"
          className="ticket-chat-icon-btn"
          disabled={disabled || sending}
          aria-label="Open emoji picker"
        >
          :)
        </button>
        <textarea
          value={draft}
          maxLength={MAX_LENGTH}
          onChange={(event) => setDraft(event.target.value)}
          placeholder={placeholder}
          rows={1}
          disabled={disabled || sending}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault();
              handleSend();
            }
          }}
        />
        <button
          type="button"
          onClick={handleSend}
          disabled={!canSend}
          className="ticket-chat-send-btn"
        >
          {sending ? "..." : ">"}
        </button>
      </div>
      <div className="ticket-chat-composer-footer">
        <span className={draft.length > MAX_LENGTH ? "danger" : ""}>{draft.length}/2000</span>
      </div>
    </div>
  );
};

export default MessageComposer;
